import { MixturaService } from 'src/app/services//mixtura.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { mixtura } from '../../../../shared/object/mixtura.model';
import { MessageRendererService } from 'src/app/services/message-renderer.service';

@Component({
  selector: 'app-agregar-editar-mixtura',
  templateUrl: './agregar-editar-mixtura.component.html',
  styleUrls: ['./agregar-editar-mixtura.component.scss'],
})
export class AgregarEditarMixturaComponent implements OnInit {
  formHeader: FormGroup;

  @ViewChild('AddEditMixtura', { static: true }) addEditMixtura: ModalDirective;
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutUsuario: number;

  //variables
  selectMixtura: mixtura;

  //utils
  private log: any;
  mode: string = '';
  mixturaselect: any = {};

  constructor(
    private clog: ConsoleService,
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private mixturaService: MixturaService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('Mixtura ADD/EDIT');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.selectMixtura = {
      codigo: null,
      nombre: '',
      activado: true,
      fecha_registro: new Date(),
    };

    this.createForms();
  }

  createForms() {
    this.formHeader = this.fb.group({
      codigo: [''],
      nombre: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]*$')]],
      activado: [true],
    });
  }

  //MOSTRAR MODAL AGREGAR
  show() {
    this.mode = 'ADD';
    this.addEditMixtura.show();
    this.resetAndSetDefaults();
  }

  //RESETEAR VALORES
  resetAndSetDefaults() {
    this.formHeader.reset();
    this.formHeader.get('activado').setValue(true);
  }

  //CERRAR EL AGREGAR/EDITAR MODAL
  CerrarAgregarEditarMixtura() {
    this.resetAndSetDefaults();
    this.addEditMixtura.hide();
  }

  //MOSTRAR MODAL EDITAR
  load(mixturaSeleccionado) {
    this.mixturaselect = mixturaSeleccionado;
    this.mode = 'EDIT';
    this.addEditMixtura.show();
    this.formHeader.get('activado').setValue(mixturaSeleccionado.activado);
    this.formHeader.get('nombre').setValue(mixturaSeleccionado.nombre);
  }

  AgregarEditarMixtura() {
    if (this.mode == 'ADD') {
      this.selectMixtura.nombre = this.formHeader.controls['nombre'].value;
      const inputParams = {
        entidad: this.selectMixtura,
      };
      this.mixturaService.AgregarMixtura(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        this.onSuccess.emit(); //Al ser una operacion exitosa se actualizará la lista
        this.addEditMixtura.hide();
        this.toastService.success('Operación exitosa');
      });
    } else if (this.mode == 'EDIT') {
      this.mixturaselect.nombre = this.formHeader.controls['nombre'].value;
      this.mixturaselect.fecha_registro = new Date();
      const inputParams = {
        entidad: this.mixturaselect,
      };

      delete inputParams.entidad.__typename;
      this.mixturaService.EditarMixtura(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        this.onSuccess.emit(); //Al ser una operacion exitosa se actualizará la lista
        this.addEditMixtura.hide();
        this.toastService.success('Operación exitosa');
      });
    }
  }
}
